var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
      'active': _vm.active
  },attrs:{"id":"burger"},on:{"click":_vm.toggleActive}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"burger-button",attrs:{"type":"button","title":"Menu"}},[_c('span',{staticClass:"burger-bar burger-bar--1"}),_c('span',{staticClass:"burger-bar burger-bar--2"}),_c('span',{staticClass:"burger-bar burger-bar--3"})])
}]

export { render, staticRenderFns }